module.exports = __webpack_public_path__ + "static/media/money-inflation-finance.84975378.gif";